import React from 'react';
// import ReactDOM from 'react-dom';
import { render } from 'react-snapshot';
// Before App: fixes the order of all stylesheets (see globalStyles.js).
import './globalStyles';
import App, { primeLanding } from './App';
import { installBackdropClose } from './utility/backdropClose';
import { authReady } from './firebase.config';
import * as serviceWorker from './serviceWorker';
import { isFileRoute, openFileRoute, removeFileWorker } from './utility/fileView';
import './index.css';
// Last: 16px fields on phones (iPhone zooms in on smaller ones).
import './mobileInputs.css';


// A click on any popup's backdrop closes it, as its X does (utility/backdropClose).
installBackdropClose();

const root = document.getElementById('root');
let mounted = false;
const mount = () => {
  if (mounted) return;
  mounted = true;
  // //ReactDOM.render(
  render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    root
  );
};

// A prerendered page (the home, /certified, /faq...) is already on screen, and
// React's first render replaces it. Until now that first render was the
// full-screen loader while Auth answered, then the page again: a flash, and on
// phones the page's largest paint moved to the second drawing (LCP 14 s). So
// the first render waits for Auth's answer and for this screen's code, and
// then draws the same page over itself. Never more than 4 s.
// A PDF's own address (/archivo/<name>, utility/fileView.js) that reached the
// app instead of its worker: no page to draw, it installs the worker or goes
// to the file.
if (isFileRoute()) {
  openFileRoute();
} else if (root && root.firstElementChild) {
  Promise.all([authReady, primeLanding()]).then(mount, mount);
  setTimeout(mount, 4000);
} else {
  mount();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// The one that opens PDFs with their name, where it isn't used (phones).
removeFileWorker();
